<div class="layout-col full bg-background" style="width: 30vw">
  <app-action-detail class="flex" [action]="action" (close)="onClose($event)"> </app-action-detail>
</div>
